import React, {Component} from 'react';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// require('datatables.net-responsive');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: '#ID',
    data: 'TRAINING_ID'
  },
  {
    title: 'ชื่อหลักสูตร',
    data: 'TRAINING_NAME'
  },
  {
    title: 'ตำแหน่งผู้เรียน',
    data: 'TRAINING_GROUP_NAME'
  },
  {
    title: 'สถานที่อบรม',
    data: 'TRAINING_VENUE'
  },
  {
    title: 'วันที่อบรม',
    data: 'TRAINING_DATE'
  },
  {
    title: 'เวลาเริ่มอบรม',
    data: 'TRAINING_TIME_START'
  },
  {
    title: 'เวลาสิ้นสุดอบรม',
    data: 'TRAINING_TIME_END'
  },
  {
    title: 'รหัสพนักงาน',
    data: 'TRAINEE_EMP_ID'
  },
  {
    title: 'ชื่อพนักงาน',
    data: 'TRAINEE_NAME'
  },
  {
    title: 'สายงาน',
    data: 'TRAINEE_LINEOFWORK'
  },
  {
    title: 'ตำแหน่ง',
    data: 'TRAINEE_POS'
  },
  {
    title: 'แผนก',
    data: 'TRAINEE_DEP'
  },
  {
    title: 'บริษัท',
    data: 'TRAINEE_COMP'
  },
  {
    title: 'ระดับตำแหน่ง',
    data: 'TRAINEE_LEVEL'
  },
  {
    title: 'ชั่วโมงเรียน (เวลาสิ้นสุดลบเวลาเริ่ม)',
    data: 'HOUR'
  },
  {
    title: 'BU',
    data: 'BU'
  },
  {
    title: 'คะแนน PRE (ถ้ามี)',
    data: 'PRE'
  },
  {
    title: 'คะแนน POST (ถ้ามี)',
    data: 'POST'
  },
  {
    title: 'PASS / NOT PASS',
    data: 'RESULT',
    render: function (data, type, row) {
      if (data === 'pass') {
        return '<span style="color:green;font-weight:bold;">PASS</span>';
      } else if (data === 'not pass') {
        return '<span style="color:red;font-weight:bold;">NOT PASS</span>';
      }
      return data;
    }
  },
  {
    title: 'ประเภทการจัดอบรม',
    data: 'TRAINING_PLACE'
  },
  {
    title: 'รูปแบบการจัด',
    data: 'TRAINING_TYPE_V2'
  },
  {
    title: 'หมวดหลักสูตร',
    data: 'TRAINING_GROUP'
  },
  {
    title: 'สถานะพนักงาน',
    data: 'STATUS'
  },
  {
    title: 'ค่าอบรม (คน/ต่อหลักสูตร)',
    data: 'COST_PER_PERSON'
  },
  {
    title: 'ค่าอบรมรายบุคคล (ทั้งหมด)',
    data: 'COST_TOTAL'
  }
];

function reloadTableData(names, page) {
  console.log('reload: ' + names.length);
  const table = $(`#${id}`).DataTable();

  table.clear();
  table.rows.add(names);
  table.draw();
  table.page(page).draw('page');
  setTimeout(function () {
    table.columns.adjust();
  }, 50);
}

class TableReport1 extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var table = $(`#${id}`).DataTable({
      data: this.props.names,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[0, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      errMode: 'none',
      scrollX: true
    });

    table.on('page', (event) => {
      var info = table.page.info();
      console.log(info.page);
      this.props.onPageChange(info.page);
    });

    $.fn.dataTable.ext.errMode = 'none';
    // table.columns.adjust();
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    reloadTableData(nextProps.names, nextProps.page);
    return true;
  }

  render() {
    return (
      <div>
        <table
          ref="main"
          className="display nowrap example"
          id={id}
          style={{width: '100%'}}
        />
      </div>
    );
  }
}
export default TableReport1;
